<template>
  <form class="was-validated" novalidate @submit="onCheckForm">
    <mdb-input label="사용자 ID" v-model="user.userId" disabled/>
    <mdb-input label="이름*" v-model="user.name"
      required invalidFeedback="이름은 필수 항목입니다."/>
    <div> 성별:
      <label><input type="radio" v-model="user.gender" value="남"> 남</label>
      <label class="ml-3"><input type="radio" v-model="user.gender" value="여"> 여</label>
    </div>
    <mdb-input label="email*" type="email" v-model="user.email"
      required invalidFeedback="email 양식이 아닙니다."/>
    <mdb-input label="전화번호(010-xxxx-xxxx)"  v-model="cellphone"/>
    <mdb-input label="주소" v-model="user.address"/>
    <div class="text-center">
      <mdb-btn type="submit" icon="check" :disabled="!isValid">확인</mdb-btn>
      <mdb-btn icon="undo" @click="$emit('mode-change', false)">취소</mdb-btn>
    </div>
  </form>
</template>
<script>
import { mdbInput, mdbBtn } from 'mdbvue';
export default {
  name: 'ProfileEdit',
  components: { mdbInput, mdbBtn },
  props: ['user'],
  data: function () {
    return {
      cellphone: this.$cellPhone(this.user.cellPhone)
    }
  },
  computed: {
    isValid () {
      const { name, email } = this.user
      return name.length && email.length
    }
  },
  methods: {
    onCheckForm (event) {
      event.preventDefault();
      if (this.cellphone && this.cellphone !== '') {
        const nums = this.cellphone.split('-')
        if (nums.length !== 3) {
          alert('전화번호 형식이 틀렸습니다.')
          return
        }
        this.user.cellPhone = {
          number1: nums[0],
          number2: nums[1],
          number3: nums[2]
        }
      }
      if (!confirm('저장할까요?')) {
        return;
      }
      this.$emit('change-profile')
    }
  }
}
</script>
